module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Ancient-Assassins-2.29725be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Ancient-Assassins-2.jpg
// module id = 53sA
// module chunks = 0